<!-- 专业测评报告 -->
<template>
  <!-- :style="{
          background: `url(${bgImg})`,
          'background-repeat': 'no-repeat',
          'background-size': '100% 1729px',
        }" -->
  <div class="container">
    <img class="pageImg" src="@/assets/images/home/pageBg3.png" alt="" />
    <div
      class="professionalReport"
      :style="{
        paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
      }"
    >
      <div class="navigator"
       :style="{
        backgroundImage: `url(${BgImg})`,
        backgroundSize: '100% auto',
      }">
        <div class="back_share" v-if="platform == 'app'" :style="{
        paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
      }">
          <img
            class="back_img"
            src="@/assets/images/home/back@2x.png"
            @click="back()"
            @touchmove.stop.prevent
            alt
          />
          <div>测评报告</div>
          <img
            @click.stop="shareHandle()"
            class="share_img"
            src="@/assets/images/home/share.png"
            alt
          />
        </div>
        <div class="test_info">
          <div class="test_img_bg">
            <img
              class="test_img"
              src="@/assets/images/home/test_icon.png"
              alt=""
            />
          </div>
          <div class="test_info_content">
            <div class="test_name">{{ detailData.assessmentTitle }}</div>
            <div class="test_time">
              测评时间：
              {{ detailData.generateTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="pageContent">
        <!-- 基础信息 -->
        <div class="content">
          <div class="content_box">
            <div class="module_box" :style="{
                  background: `url(${bgImg})`,
                  'background-repeat': 'no-repeat',
                  'background-size': '100% 100%',
                }">
              <!-- :style="{
                  background: `url(${analyzeBg})`,
                  'background-repeat': 'no-repeat',
                  'background-size': '100% 100%',
                }" -->
              <div class="content_title_box">
                <div class="module_content">
                  <div class="dimensionTitle">
                {{ detailData.dimensionTitle }}
              </div>
                  <!-- 图表 -->
                  <div
                    class="chartContent"
                  >
                    <!-- 仪表盘 -->
                    <!--  -->
                    <!-- <template
                      v-if="
                        detailData.chartDataType === 'SUM_SCORE' ||
                          detailData.chartDataType ===
                            'SUM_SCORE_PERCENT_SIGN' ||
                          detailData.chartDataType === 'SUM_SCORE_PERCENT'
                      "
                    > -->
                      <div id="GAUGE" style="width: 250px; height: 150px"></div>
                    <!-- </template>
                    <template v-else>
                      <div
                        v-for="(dimension, dIdx) in detailData.data
                          .dimensionData"
                        :key="dIdx"
                      >
                        <div
                          :id="'GAUGE' + dIdx"
                          style="width: 168px; height: 168px"
                        ></div>
                        <div class="demi_title">{{ dimension.dimension }}</div>
                      </div>
                    </template> -->
                  </div>
                  <!-- <div class="charts_desc">
                {{ detailData.chartDesc }}
              </div> -->
                </div>
                <!-- <div
                  class="content_title"
                  :style="{
                    background: `url(${analyzeTitleBg})`,
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                  }"
                >
                  解析概览
                </div> -->
              </div>
            </div>
            <div class="module_list" style="padding:8px">
              <div style="width: 100%; height: 20px;"></div>
              <div v-html="px2vwHtml(detailData.description)"></div>
              <div style="width: 100%; height: 20px;"></div>
            </div>
            <div class="module_list">
              <div
                class="module_item"
                v-for="(item, index) in detailData.angles"
                :key="index"
              >
                <div class="item_title_box">
                  <div class="title_line"></div>
                  <div class="module_item_title">
                    {{ item.textTitle }}
                  </div>
                </div>
                <div v-if="item.type == 'IMAGE'">
                  <div
                    class="module_item_img_content"
                    v-for="(child, index) in item.images"
                    :key="index"
                  >
                    <div class="module_item_img_name">
                      {{ child.imageName }}
                    </div>
                    <div class="module_item_img_box">
                      <img
                        class="module_item_img"
                        :src="child.imageUrl"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div v-if="item.type == 'TEXT'" class="module_item_text_box">
                  <div class="module_item_text" v-html="px2vwHtml(item.textContent)"></div>
                </div>
              </div>
              <!-- 总结 -->
              <div class="content_conclusion2" v-if="detailData.summary">
                <div class="content_conclusion_bg">
                  <div class="content_conclusion_text1">
                    {{ detailData.summary }}
                  </div>
                </div>
                <div class="content_conclusion_text2">
                  {{ detailData.summary }}
                </div>
              </div>
            </div>
            <!-- </div> -->
            <!-- 去聊聊 -->
            <div
              class="liao_box"
              @click="toTalk"
              :style="{
                background: `url(${liaoBg})`,
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%',
              }"
            >
              <div
                class="liao_text"
                
              >
                <div class="liao_text_title">
                  想要进一步探讨你的{{ detailData.cardCategoryTwo }}人格，
                </div>
                <div class="liao_text_title">获取更个性的建议和支持吗？</div>
              </div>
              <!-- <div class="liao_text_btn">来找朏朏聊聊吧！</div> -->
            </div>
          </div>
          <!-- 是否推荐 -->
          <div
            class="recommend_yes_no"
            :style="{
              background: `url(${recommendBg})`,
              'background-repeat': 'no-repeat',
              'background-size': '100% 100%',
            }"
          >
            <div class="recommend_title">您觉得这个测评怎么样？</div>
            <div class="recommend_btn">
              <div class="btn_item" @click="isRecommend(true)">
                <div class="btn_item_text">推荐</div>
                <img
                  v-if="detailData.isRecommend===true"
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_yes_active.png"
                  alt=""
                />
                <img
                  v-else
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_yes.png"
                  alt=""
                />
              </div>
              <div class="btn_item" @click="isRecommend(false)">
                <div class="btn_item_text">不推荐</div>
                 <img
                  v-if="detailData.isRecommend===false"
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_no_active.png"
                  alt=""
                /><img
                  v-else
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_no.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- 相关推荐 -->
          <div class="recommend">
            <img
              class="recommend_img"
              src="@/assets/images/home/popular.png"
              alt=""
            />
            <div class="recommend_box">
            <div
              class="recommend_item"
              v-for="(item, index) in recommendList"
              :key="index"
              @click="reduceUrl(item)"
            >
              <div class="recommend_item_theme">{{ item.theme }}</div>
              <img class="recommend_item_img" :src="item.imageUrl" alt="" />
              <div class="recommend_item_content">
                <div class="recommend_item_title">{{ item.title }}</div>
                <div class="recommend_item_subTitle">{{ item.subtitle }}</div>
                <div class="recommend_item_person_price">
                  <div class="recommend_item_personNum">
                    <img
                      class="recommend_item_personNum_icon"
                      src="@/assets/images/home/person_icon.png"
                      alt=""
                    />
                    <span class="recommend_item_personNum_text"
                      >{{ item.assessTimes }}人测过</span
                    >
                  </div>
                  <div class="recommend_item_price">
                    <span class="recommend_free_text">免费</span
                    >

                    <span
                      v-if="item.paid"
                      :class="
                        item.paid
                          ? 'recommend_item_price_free'
                          : 'recommend_item_price_normal'
                      "
                      >￥{{ item.price }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-liquidfill/src/liquidFill.js";
import { getDetail, recommendation, getReportRecommend } from "@/api/report";
import { Toast } from "vant";
import { times } from "@/utils/decimalUtils"
import { px2vwHtml } from "@/utils/mUtils";
export default {
  data() {
    // 这里存放数据
    return {
      detailData: {},
      id: "",
      reportId: "",
      type: "",
      title: "",
      bgImg: require("@/assets/images/report/bg_p.png"),
      tagsBg: require("@/assets/images/home/tagsBg.png"),
      analyzeBg: require("@/assets/images/home/analyzeBg.png"),
      analyzeTitleBg: require("@/assets/images/home/analyzeTitleBg.png"),
      recommendList: [],
      liaoBg: require("@/assets/images/report/lliaoliao_bg.png"),
      textBg: require("@/assets/images/report/text_bg.png"),
      recommendBg: require("@/assets/images/report/recommend_bg.png"),
      BgImg: require("@/assets/images/home/pageBg3.png"),
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    px2vwHtml,
    reduceUrl(item) {
      // console.log("---相关推荐", item);
      const id = item.id;
      const type = item.category === "FUN" ? 1 : 2;
      this.$router.push({
        path: "/home",
        query: {
          id,
          type,
        },
      });
    },
    shareHandle() {
      const path = encodeURIComponent("Main");
      const params = {
        pageIndex: 0,
      };
      const encodeParams = encodeURIComponent(JSON.stringify(params));
      const url = `${this.$ShareUrl}/share?platform=wx&linkId=usr1jvrml77haac0&path=${path}&params=${encodeParams}`;
      let data = {
        title: this.detailData.assessmentTitle,
        img: this.detailData.cardImageUrlMy,
        url,
      };
      console.log("share - bridge", data);
      this.$bridge.call("share", data);
    },
    back() {
      this.bridgeClose();
    },
    async getDetailData() {
      const res = await getDetail({ id: this.reportId });
      this.detailData = res.data;
      res.data.dimensionDetail.dimensionSegments.map(d=>{
        if(d.title === res.data.dimensionTitle){
          this.detailData.description = d.description
        }
      })
      this.detailData.generateTime = new Date(
        this.detailData.generateTime * 1
      ).format("yyyy-MM-dd hh:mm");
      this.$nextTick(() => {
        this.getChartData('GAUGE', this.detailData);
      });
    },
    async getChartData(name, data) {
      // let formatterValue = data.dimensionFormula === "PERCENT" ? times(data.dimensionSumScore,100): data.dimensionSumScore;
      let formatterValue =  data.dimensionSumScore;
      let title = data.dimensionTitle;
      if (data.chartDataType == "DIMENSION_SCORE") {
        // 各维度分数
        console.log(this.detailData.data);
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (
        data.chartDataType == "DIMENSION_SCORE_PERCENT_SIGN" ||
        data.chartDataType == "DIMENSION_SCORE_PERCENT"
      ) {
        // 各维度分数百分比
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (
        data.chartDataType == "SUM_SCORE_PERCENT_SIGN" ||
        data.chartDataType == "SUM_SCORE_PERCENT"
      ) {
        // 总分百分比
        formatterValue =
          data.data.totalScorePercentage +
          (data.chartType == "GAUGE" ? "" : "%");
        console.log("kankan baifenbi", formatterValue);

        title = data.chartTitle || "";
      } else if (data.chartDataType == "RESULT") {
        // 结果
        formatterValue = "";
      } else if (data.chartDataType == "SUM_SCORE") {
        // 总分
        formatterValue = data.data.totalScore;
        title = "总得分";
      }
      console.log("---formatterValue", formatterValue);

      if (name == "GAUGE") {
        console.log("----看看name是不是GAUGE", name, data);
        // if (
        //   data.chartDataType === "SUM_SCORE" ||
        //   data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
        //   data.chartDataType === "SUM_SCORE_PERCENT"
        // ) {
          this.initGauge(name, data, title, formatterValue);
        // } else {
        //   // 多个图表渲染
        //   if (data.data.dimensionData.length > 0) {
        //     data.data.dimensionData.map((d, dIdx) => {
        //       this.initGauge(`${name}${dIdx}`, data, d.dimension, d.score);
        //     });
        //   }
        // }
      } else if (name == "WATERWAVE") {
        console.log("----看看name是不是WATERWAVE", name);
        if (
          data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
          data.chartDataType === "SUM_SCORE_PERCENT"
        ) {
          this.initWaterWave(name, data, title, formatterValue);
        } else {
          // 多个图表渲染
          if (data.data.dimensionData.length > 0) {
            data.data.dimensionData.map((d, dIdx) => {
              this.initWaterWave(`${name}${dIdx}`, data, d.dimension, d.score);
            });
          }
        }
      } else if (name == "RADAR") {
        console.log("----看看name是不是RADAR", name, data);
        let chartDom = document.getElementById(name);
        let myChartThree = echarts.init(chartDom);
        let indicatorData = data.data.dimensionData.map((item) => {
          return {
            name: item.dimension,
            max: item.maxScore,
          };
        });
        let dimensionData = data.data.dimensionData.map((item) => {
          return item.score;
        });
        console.log(indicatorData, dimensionData);

        let option = {
          series: [
            {
              type: "radar",
              data: [{ value: dimensionData }],
              lineStyle: {
                color: "#A3EDCC",
              },
              itemStyle: {
                color: "#A3EDCC",
              },
              areaStyle: {
                color: "#A3EDCC",
              },
            },
          ],
          radar: {
            radius: "60%",
            indicator: indicatorData,
            center: ["50%", "55%"],
          },
        };
        myChartThree.setOption(option);
      }
    },
    initGauge(name, data, title, formatterValue) {
      console.log('create gauge', name, data, title, formatterValue);
      
      let chartDom = document.getElementById(name);
      let myChartOne = echarts.init(chartDom);
      let option = {
        series: [
          {
            // min:data.dimensionFormula === "PERCENT" ? times(data.dimensionMinScore,100): data.dimensionMinScore,
            // max: data.dimensionFormula === "PERCENT" ? times(data.dimensionMaxScore, 100) : data.dimensionMaxScore,
            min: 0,
            max: 100,
            data: [
              // 数据
              {
                value: formatterValue,
                name: title || "",
              },
            ],
            title: {
              // 标题
              offsetCenter: ["0%", "120%"],
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
              color: "#000",
              show: false,
            },
            detail: {
              // 详情
              valueAnimation: true,
              color: "#ffffff",
              fontStyle: "normal",
              fontWeight: "bold",
              fontFamily: "D-DIN",
              fontSize: 36,
              offsetCenter: [0, 0],
              // formatter: "{value}",
              formatter(value) {
                // if (
                //   data.dimensionFormula === "PERCENT"
                // ) {
                //   return value + "%";
                // } else {
                  return value + `{a|分}`;
                // }
              },
              rich: {
                a: {
                  color: "#fff",
                  fontSize: 16,
                },
              },
            },
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            radius: "100%",
            center: ["50%", "70%"],
            splitNumber: 1, //刻度数量
            itemStyle: {
              color: "#58D9F9",
              shadowColor: "rgba(255,255,255,0.45)",
              shadowBlur: 10,
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
            progress: {
              show: true, //是否显示进度条
              width: 8,
              roundCap: true,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#ffffff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ffffff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            pointer: {
              show: false, //是否显示指针
              roundCap: true,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#79E695", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#5AD8B7", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            axisLine: {
              // 轴线
              show: false,
              roundCap: true,
              lineStyle: {
                width: 6,
              },
              color: "#A4FDCA", // 设置单一颜色为红色
            },
            axisTick: {
              // 刻度
              show: false,
            },
            splitLine: {
              // 分隔线
              show: false,
            },
            axisLabel: {
              // 刻度标签
              show: false,
              distance: -50,
              color: '#999',
            },
            anchor: {
              show: false, // 指针中心点
            },
          },
          {
            type: "gauge",
            radius: "100%",

            center: ["50%", "70%"],
            startAngle: 180,
            endAngle: 0,
            itemStyle: {
              color: "#ffffff85",
            },
            progress: {
              show: true,
              roundCap: true,

              width: 6,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: false,
            },
            data: [
              {
                value: 100,
              },
            ],
          },
        ],
      };
      myChartOne.setOption(option);
    },
    initWaterWave(name, data, title, formatterValue) {
      let chartDom = document.getElementById(name);
      let myChartTwo = echarts.init(chartDom);
      let option = {
        series: [
          {
            type: "liquidFill",
            // name: title || "",
            radius: "80%", //显示比例
            center: ["50%", "50%"], //中心点
            amplitude: 5, //水波振幅
            data: [
              formatterValue / 100,
              formatterValue / 100,
              formatterValue / 100,
            ], // data个数代表波浪数
            color: ["#A4FDCA "], //波浪颜色
            backgroundStyle: {
              borderWidth: 6, //外边框
              borderColor: "#A4FDCA ", //边框颜色
              color: "#62DCAE", //边框内部填充部分颜色
            },
            label: {
              //标签设置
              position: ["50%", "50%"],
              // formatter(value) {
              //   return title + "\n\n" + formatterValue;
              // }, //显示文本,
              formatter: formatterValue,
              fontSize: "20px", //文本字号,
              color: "#fff",
            },
            outline: {
              show: false, //最外层边框显示控制
            },
            title: {
              // 标题
              offsetCenter: ["0%", "120%"],
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
              color: "#ff00ff",
              show: true,
            },
          },
        ],
      };
      myChartTwo.setOption(option);
    },
    // 跳转小程序聊聊
    toTalk() {
      if (this.platform === "app") {
        this.bridgeRoute({
          path: "Main",
          params: JSON.stringify({ pageIndex: 2 }),
        });
      } else if (this.platform === "wx") {
        this.$wx.miniProgram.navigateTo({ url: `/pages/index/home?index=2` });
      }
    },
    async isRecommend(val) {
      if(this.detailData.isRecommend==="" || this.detailData.isRecommend===null){
        const res = await recommendation({
          id: this.id,
          answerId: this.reportId,
          recommend: val,
        });
        if (res.msg == "success") {
          this.getDetailData();
          Toast("感谢您的反馈~");
        }
      }else{
        Toast("您已反馈过啦~")
      }
    },
    // 获取推荐测评列表
    async getRecommendList() {
      const res = await getReportRecommend({ id: this.id });
      this.recommendList = res.data;
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.id = this.$route.query.id;
    this.reportId = this.$route.query.reportId;
    this.type = this.$route.query.type;
    this.title = this.$route.query.title;
    this.getDetailData();
    this.getRecommendList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variable.scss";
$ListHeight: calc(100vh - 120px);
.container {
  color: #333333;
  height: 100vh;
  background-color: #f3f4f6;
}
.pageImg {
  width: 100%;
  position: fixed;
  top: -660px;
  left: 0;
}
.professionalReport {
  overscroll-behavior: none;
  overflow-y: auto;
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  /* background-color: #f3f4f6; */
  /* padding-bottom: 220px; */

  .navigator {
    width: 100vw;
  background-position-y: -660px;
    /* height: 85px; */
    color: #292929;
    position: fixed;
    top: 0px;
    left: 0;
    z-index: 2;
    .back_share {
      width: 100%;
      padding: 18px 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .back_img {
        width: 21px;
        height: 38px;
      }
      .nav_title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #292929;
        line-height: 72px;
      }
      .share_img {
        width: 38px;
        height: 38px;
      }
    }
    .test_info {
      display: flex;
      align-items: center;
      padding: 18px 36px;
      .test_img_bg {
        width: 70px;
        height: 70px;
        background-color: #ffffff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        .test_img {
          width: 70px;
          height: 70px;
        }
      }
      .test_info_content {
        .test_name {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #292929;
        }
        .test_time {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #292929;
        }
      }
    }
  }
  .pageContent {
    /* overscroll-behavior: none; */
    flex: 1;
    width: 100%;
    /* height: 100vh; */
    /* overflow-y: auto; */
    padding-top: 50px;
    position: relative;
    top: 200px;
    left: 0;
    .content {
      padding: 0 20px;
      background: linear-gradient(transparent 10%, #f3f4f6 35%, #f3f4f6 100%);

      .result_type_box {
        margin: 0 auto;
        margin-top: 100px;
        margin-bottom: 50px;
        width: fit-content;
        text-align: center;
        .result_type_top {
          position: relative;
          display: inline-block;
          padding: 20px 0px 0px 20px;
          .result_icon {
            width: 59px;
            height: 22px;
            position: absolute;
            top: 0;
            right: -24px;
          }
          .result_type {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 33px;
            background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .result_type_bottom {
          position: relative;
          padding: 0px 20px 20px 30px;
          .result_subtitle {
            font-family: Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 49px;
            background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .left_icon {
            width: 53px;
            height: 30px;
            position: absolute;
            left: 0px;
            bottom: 0;
          }
        }
      }
      .tags_box {
        padding: 30px 40px;
        margin-bottom: 21px;
        .tags_title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 36px;
          color: #36b28d;
          margin-left: 8px;
        }
        .tags_list {
          .tags_item {
            display: flex;
            margin-top: 22px;
            .tags_text {
              position: relative;
              padding: 0 15px;
              font-family: PingFang SC;
              font-weight: bold;
              font-size: 26px;
              color: #222222;
              line-height: 1.5; /* 确保文本不会与背景重叠 */
              z-index: 2; /* 确保背景在文本后面 */
            }

            .tags_text::before {
              content: "";
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 100%;
              height: 50%; /* 背景颜色占一半高度 */
              background-color: var(--tag-color); /* 使用 CSS 变量 */
              border-top-left-radius: 8px; /* 左上角圆角 */
              border-top-right-radius: 8px; /* 右上角圆角 */
              border-bottom-left-radius: 8px; /* 左上角圆角 */
              border-bottom-right-radius: 8px; /* 右上角圆角 */
              z-index: -1; /* 确保背景在文本后面 */
            }
            // .tags_text {
            //   padding: 0 15px;
            //   font-family: PingFang SC;
            //   font-weight: bold;
            //   font-size: 26px;
            //   color: #222222;
            // }
          }
        }
      }
      .content_box {
        background: #ffffff;
        border-radius: 30px;
        .module_box {
          width: 711px;
          height: 421px;
          //   margin-bottom: 23px;
          border-top-left-radius: 30px;
          border-top-right-radius: 30px;
          .content_title_box {
            padding: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            /* background: linear-gradient(180deg, #5ad8b7, #88f5d8); */
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            .content_title {
              width: 307px;
              height: 62px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 32px;
              color: #222222;
            }
          }
          .module_content {
            width: 100%;
            padding: 23px 21px;
            text-align: center;
            // background-color: #ffffff;
            .content_description {
              margin: 20px;
              padding: 21px 18px 23px 22px;
              background: #f5faf9;
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #282828;
              line-height: 40px;
            }
            .chartContent {
              display: flex;
              justify-content: center;
              #chartOne {
                // margin-left: 150px;
              }
              #chartTwo {
                // margin-left: 150px;
              }
            }
            .charts_desc {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #282828;
              margin-top: 46px;
            }
            .dimensionTitle{
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 40px;
              color: #ffffff;
              /* margin-top: 46px; */
            }
          }
        }
        .module_list {
          background: #ffffff;
          border-top-left-radius: 30px;
          border-top-right-radius: 30px;
          margin-top: -50px;
          .module_item {
            .item_title_box {
              display: flex;
              align-items: center;
              padding: 25px 20px 20px 20px;
              .title_line {
                width: 5px;
                height: 25px;
                background: #fade22;
                border-radius: 2px;
                margin-right: 15px;
              }
              .module_item_title {
                font-family: PingFang SC;
                font-weight: bold;
                font-size: 28px;
                color: #222222;
              }
            }
            .module_item_img_content {
              .module_item_img_name {
                padding: 7px 27px 12px 18px;
                display: inline-block;
                background: linear-gradient(90deg, #ffffff 0%, #a4fdca 100%);
                border-radius: 0px 22px 22px 0px;
              }
              .module_item_img_box {
                padding: 0px 20px 0px 20px;
                margin-bottom: 24px;
                .module_item_img {
                  width: 100%;
                  height: 100%;
                  margin-top: 22px;
                  padding-bottom: 22px;
                  border-bottom: 1px dashed #ededed;
                }
              }
            }
            .module_item_img_content:last-child {
              .module_item_img_box {
                margin-bottom: 0;
                .module_item_img {
                  border-bottom: 1px solid #ededed;
                }
              }
            }
            .module_item_text_box {
              padding: 0px 20px 20px 20px;
              .module_item_text {
                padding-bottom: 20px;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #282828;
                border-bottom: 1px solid #ededed;
              }
            }
          }
          .content_conclusion2 {
            position: relative;
            padding-bottom: 50px;
            .content_conclusion_bg {
              width: calc(100% - 20px);
              margin-left: 20px;
              padding: 14px 0 0 16px;
              background: linear-gradient(90deg, #9ee0c3 0%, #ffffff 46%);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #222222;
            }
            .content_conclusion_text1 {
              width: 648px;
              box-sizing: border-box;
              padding: 42px 14px 20px 16px;
              box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              line-height: 40px;
              color: transparent;
            }
            .content_conclusion_text2 {
              width: 648px;
              box-sizing: border-box;
              padding: 42px 14px 37px 16px;
              background: #ffffff;
              box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 26px;
              line-height: 40px;
              color: #222222;
              position: absolute;
              top: 14px;
              left: 36px;
            }
          }
        }
      }
    }
    .liao_box {
      width: 713px;
      height: 211px;
      padding: 75px 45px 31px 65px;
      .liao_text {
        width: 367px;
        height: 75px;
        text-align: center;
        .liao_text_title {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #222222;
        }
      }
      .liao_text_btn {
        font-family: Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #54c394;
        margin-left: 47px;
      }
    }
    .recommend_yes_no {
      height: 214px;
      padding: 29px 20px;
      margin-top: 23px;
      .recommend_title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 26px;
        color: #222222;
      }
      .recommend_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 67px;
        .btn_item {
          display: flex;
          align-items: center;
          .btn_item_text {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 24px;
            color: #222222;
            margin-right: 39px;
          }
          .btn_item_img {
            width: 40px;
            height: 40px;
          }
        }
        .btn_item:first-child {
          margin-right: 89px;
        }
      }
    }
    .recommend {
      width: 100%;
      margin-top: 25px;
      .recommend_img {
        width: 175px;
        height: 38px;
      }
      .recommend_box {
        margin-top: 20px;
        .recommend_item {
          display: flex;
          align-items: center;
          padding: 15px 20px;
          background: #ffffff;
          border-radius: 22px;
          margin-bottom: 20px;
          .recommend_item_img {
            width: 147px;
            height: 144px;
            margin-right: 18px;
            border-radius: 10px;
          }
          .recommend_item_content {
            width: 100%;
            .recommend_item_title {
              font-family: PingFang SC;
              font-weight: 800;
              font-size: 28px;
              color: #282828;
              line-height: 40px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .recommend_item_subTitle {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #282828;
              line-height: 40px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .recommend_item_person_price {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 20px;
              .recommend_item_personNum {
                display: flex;
                align-items: center;
                .recommend_item_personNum_icon {
                  width: 22px;
                  height: 22px;
                }
                .recommend_item_personNum_text {
                  font-family: PingFang SC;
                  font-weight: 400;
                  font-size: 22px;
                  color: #282828;
                  margin-left: 8px;
                }
              }
            }
            .recommend_item_price {
              .recommend_free_text {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #f36060;
                line-height: 40px;
              }
              .recommend_item_price_free {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #f36060;
                line-height: 40px;
                margin-left: 10px;
                text-decoration: line-through;
              }
              .recommend_item_price_normal {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #f36060;
                line-height: 40px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
